import { render, staticRenderFns } from "./PaymentChoices.vue?vue&type=template&id=2078c06c&scoped=true"
import script from "./PaymentChoices.vue?vue&type=script&lang=js"
export * from "./PaymentChoices.vue?vue&type=script&lang=js"
import style0 from "./PaymentChoices.vue?vue&type=style&index=0&id=2078c06c&prod&lang=scss&scoped=true"
import style1 from "./PaymentChoices.vue?vue&type=style&index=1&id=2078c06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078c06c",
  null
  
)

export default component.exports